/**
 * Created by stonewang on 2017/9/11.
 */
import {config, request} from 'Utils';

//PC查询渠道赋能的评论列表
export function commentListByPC(param) {
  /*
   {
   "content": "string",
   "newsId": 0,
   "p": 0,
   "s": 0,
   }
  * */
  return request(`${config.server}/api/v1/dms/information/inforsCommentAllList`, {
    method: 'post',
    body: param,
  });
}
//新增渠道赋能评论(含转发)
export function insertComment(param) {
  /*
   {
   content (string, optional),
   newsId (integer, optional),
   p (integer, optional): 页码 ,
   s (integer, optional): 每页条数 ,
   }
  * */
  return request(`${config.server}/api/v1/dms/information/insertInforsComment`, {
    method: 'post',
    body: param,
  });
}
//删除渠道赋能评论
export function deleteComment(param) {
  /*
   {
   "ids": [ 0 ]
   }
   * */
  return request(`${config.server}/api/v1/dms/information/deleteInforsComment`, {
    method: 'post',
    body: param,
  });
}


// WEBPACK FOOTER //
// ./src/service/channelFunc/comment.js